import React, { FC } from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { Link } from "src/components/Link";
import { ReactComponent as GoogleIcon } from "src/assets/icons/auth/google.svg";
import { loginPopupTrns } from "./trns";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const REDIRECT_URL = process.env.REACT_APP_GOOGLE_OAUTH_REDIRECT_URL;
const GOOGLE_OAUTH_URL = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${GOOGLE_CLIENT_ID}&redirect_uri=${REDIRECT_URL}&response_type=token&scope=openid%20profile%20email`;

interface Props {
  className?: string;
}

export const GoogleLoginButton: FC<Props> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <Link href={GOOGLE_OAUTH_URL}>
      <Button
        className={cn(
          "w-full px-5 py-2 font-medium !bg-blue-dark/10 hover:!bg-blue-dark/20 border-none",
          className
        )}
        type="button"
        variant={ButtonVariants.SIMPLE_SECONDARY}
      >
        <GoogleIcon />
        <span className="flex-1"> {t(loginPopupTrns.googleLoginButton)}</span>
      </Button>
    </Link>
  );
};
